module.exports = __webpack_public_path__ + "assets/img/btn-view-3ae38abc.png";